/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

:host {
  display: flex;
}

.qds-mobile-link {
  padding-block: var(--qds-list-item-standard-padding-vertical);
  padding-inline: var(--qds-list-item-large-padding-horizontal);
}

.qds-web-link {
  padding: var(--qds-navigation-subsection-titles-gap)
    var(--qds-navigation-subsection-padding-horizontal);
}

.qds-item {
  display: flex;
  align-items: center;
  color: var(--qds-theme-text-standard);

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: -4px;
  }
}

.qds-web-list-item:hover {
  background-color: var(--qds-theme-interactive-background-hover);
}

.qds-web-list-item:active {
  background-color: var(--qds-theme-interactive-background-pressed);
}

.qds-title {
  color: var(--qds-theme-title);
}

.qds-web-subtext {
  color: var(--qds-theme-subtitle);
}

a {
  text-decoration: none;
}

.qds-texts {
  justify-items: center;
  display: flex;
  flex: 1 0;
  flex-direction: column;
  padding: 0;
}

.qds-mobile {
  width: 100%;

  .qds-item {
    padding-block: var(--qds-list-item-standard-padding-vertical);
    padding-inline: var(--qds-list-item-large-padding-horizontal);
    gap: var(--qds-list-item-large-gap-internal);
    min-height: var(--qds-list-item-standard-height);
    border-block-end: var(--qds-list-border-width) solid
      var(--qds-theme-divider-standard);
  }

  qds-icon {
    color: var(--qds-theme-text-standard);
    font-size: var(--qds-control-large-icon-size);
    transform: scaleX(var(--qds-direction-factor, 1));
  }

  .qds-title {
    font: var(--qds-list-item-large-title-emphasized);
  }

  .qds-subtext {
    font: var(--qds-list-item-large-subtitle);
  }
}

.qds-web {
  .qds-item {
    padding: var(--qds-list-item-standard-padding-vertical)
      var(--qds-list-item-standard-padding-horizontal);
    gap: var(--qds-list-item-standard-gap-internal);
  }

  img {
    max-width: var(--qds-list-item-standard-picture-size);
    max-height: var(--qds-list-item-standard-picture-size);
  }

  qds-icon {
    color: var(--qds-theme-text-standard);
    font-size: var(--qds-list-item-standard-icon-size);
  }

  .qds-title {
    font: var(--qds-list-item-standard-title-emphasized);
  }

  .qds-title-only {
    font: var(--qds-list-item-small-title);
  }

  .qds-subtext {
    font: var(--qds-list-item-standard-subtitle);
  }
}
